declare global {
    interface Window {
        clarity?: (...args: any[]) => void;
    }
}

/**
 * Initializes Microsoft Clarity if a project id is provided and script is not yet loaded.
 */
export function initClarity(projectId?: string): void {
    if (!projectId) {
        return;
    }

    if (window.clarity) {
        return;
    }

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `(
        function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        }
    )(window, document, "clarity", "script", "${projectId}");`;

    document.head.appendChild(script);
}

export {};